function TwoFactorRequired(message) {
  this.name = "TwoFactorRequired";
  this.message = message || "";
  this.stack = new Error().stack;
}
TwoFactorRequired.prototype = Object.create(Error.prototype);
TwoFactorRequired.prototype.constructor = TwoFactorRequired;

export default TwoFactorRequired;
